import React from "react"
import { Flex, Text } from "components/common"
import { TitleDescription } from "components/custom"
import { SVGDefaultDoc, SVGPdf, SVGPpt, SVGSheets, SVGWord } from "components/svgs"
import { truncateText } from "utils/reports"
import styles from "./whatsappDocument.module.less"
import { t } from "i18next"

export const WhatsappDocument = ({ parsedContent}) => {
  const extension = parsedContent?.fileName?.split(".")?.pop()
  const getIcon = () => {
    const mimeType = parsedContent?.mimeType
  
    if (mimeType == "application/pdf") {
      return <SVGPdf className={styles.docIcon} />
    } else if (
      mimeType === "application/msword" ||
      mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return <SVGWord className={styles.docIcon} />
    } else if (
      mimeType === "application/vnd.ms-excel" ||
      mimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      return <SVGSheets className={styles.docIcon} />
    } else if (
      mimeType === "application/vnd.ms-powerpoint" ||
      mimeType === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
      mimeType === "application/vnd.openxmlformats-officedocument.presentationml.template" ||
      mimeType === "application/vnd.openxmlformats-officedocument.presentationml.slideshow"
    ) {
      return <SVGPpt className={styles.docIcon} />
    }
    return <SVGDefaultDoc className={styles.docIcon} text={extension?.slice(0, 3)?.toUpperCase()} />
  }

  return (
    <Flex
      align="center"
      gap="14px"
      className={styles.docBody}
      onClick={() => parsedContent?.s3KeyValue && window.open(parsedContent.s3KeyValue, "_blank") ||  null}
    >
      {getIcon()}
      <div className={styles.docFileInfo}>
        <TitleDescription
          title={<Text className={styles.docTitle}>{truncateText(parsedContent?.fileName, 75)|| t("Unknown File")}</Text>}
          description={
            <Text type="secondary" className={styles.docExtension}>
              {extension?.toUpperCase() || t("Unknown File")}
            </Text>
          }
        />
      </div>
    </Flex>
  )
}
